module.exports = __webpack_public_path__ + "static/img/bg_no_coupon_on.d759651.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/padImg/bg_no_coupon_on.png
// module id = +SKz
// module chunks = 1